module.exports = __webpack_public_path__ + "media/images/teacherHome-4236858cf83b6beb475aca0da1bdfd2e.jpg";